// extracted by mini-css-extract-plugin
module.exports = {"adBlock":"BOIAoK","closeModal":"_3y4FFW","fixedSize":"_1oQ1pe"};